import { styled } from "@/stitches/config"

export const SDivider = styled("hr", {
  width: "100%",
  height: 1,
  border: "none",
  margin: 0,
  backgroundColor: "$theme-n3-n7",
  transition: "150ms ease-out",
})
